import React from 'react';
import './App.css';
import {Midi} from './Midi';
import {MidiRouter} from './MidiRouter';
import {MidiRecorder} from "./MidiRecorder";


const App: React.FC = () => {
    const midi: Midi = new Midi();
    const recorder: MidiRecorder = new MidiRecorder();
    midi.init().then(() => {
        midi.registerCallback(console.log);
        midi.registerCallback(MidiRouter.routeToAllOutputs);
        midi.addMidiDevice(recorder.getMidiInput());
        midi.addMidiDevice(recorder.getMidiOutput());
    }).catch(console.log);
    return (

        <div className="App">
            <header className="App-header">
                <p style={{cursor: "pointer"}} className="noselect"
                   onClick={(event) => recorder.playPause()}>
                    Click here to replay/pause recorded MIDI
                </p>
            </header>
        </div>
    );
};

export default App;
